import { render, staticRenderFns } from "./clientOrderList.vue?vue&type=template&id=725cf025&scoped=true&"
import script from "./clientOrderList.vue?vue&type=script&lang=js&"
export * from "./clientOrderList.vue?vue&type=script&lang=js&"
import style0 from "./clientOrderList.vue?vue&type=style&index=0&id=725cf025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725cf025",
  null
  
)

export default component.exports